import { getCalculatedField, getStep } from '../../../components/CASAForm/Utilities';

import {
    ADD_CALCULATED_FIELD,
    ADD_STEP,
    SETCURRENT_STEP,
    ADD_LOADED_DRAFT_FORM
} from '../../Actions/FormDataActions/GenericFormDataAction';

const initialState = {
    currentstep: "",
    steps: [],
    calcs: []
};

export default function formReducer(state = initialState, action) {
    let currentstep;
    let step;
    let updatedCalculatedField;
    let calculatedField;

    switch (action.type) {
        case SETCURRENT_STEP:
            return {
                ...state,
                currentstep: action.payload
            };

        case ADD_CALCULATED_FIELD:
            calculatedField = getCalculatedField(action.payload.id, state);

            if (calculatedField?.index === -1 || !calculatedField?.value) {
                calculatedField = {
                    id: action.payload.id,
                    actualValue: action.payload.actualValue,
                    displayValue: action.payload.displayValue
                };

            } else {
                updatedCalculatedField = action.payload
                return {
                    ...state,
                    calcs: [
                        ...state.calcs.slice(0, calculatedField.index),
                        updatedCalculatedField,
                        ...state.calcs.slice(calculatedField.index + 1)
                    ]
                };
            }

            return {
                ...state,
                calcs: [
                    ...state.calcs,
                    calculatedField
                ]
            }

        case ADD_STEP:
            //find and add/replace step in array
            currentstep = 0;
            step = getStep(action.payload.stepid, state)

            if (step.stepindex === -1) {
                 step = {
                    stepid: action.payload.stepid,
                    name: action.payload.name,
                    questions: action.payload.questions,
                };
            } else {
                const updatedStep = action.payload;
                const exisitingStepIndex = state.steps.findIndex(step => step.stepid === action.payload.stepid);

                return {
                    ...state,
                    currentstep: currentstep,
                    steps: [
                        ...state.steps.slice(0, exisitingStepIndex),
                        updatedStep,
                        ...state.steps.slice(exisitingStepIndex + 1)
                    ]
                };
            }

            if (state.steps.length > 0) {
                currentstep = state.steps[0].stepid;
            }
            return {
                ...state,
                currentstep: currentstep,
                steps: [
                    ...state.steps,
                    step
                ]
            };

        case ADD_LOADED_DRAFT_FORM: {
            const steps = action.payload.steps.map(step => {
                let currentstep = { ...step, questions: {}}

                let questions = step.questions;
                Object.keys(questions).map(keyName => {
                    currentstep.questions[questions[keyName].id] = questions[keyName];
                })

                return currentstep;
            })

            return {
                currentstep: action.payload.currentstep,
                steps: steps,
                calcs: action.payload.calcs
            }; 
        }

        default:
            return state;
    }
}
